module.exports = __webpack_public_path__ + "static/media/siddharth-sakleshpur-trip-04.c4696f71.png";